import { render, staticRenderFns } from "./SurveyButton.vue?vue&type=template&id=d07221aa&scoped=true"
import script from "./SurveyButton.vue?vue&type=script&lang=js"
export * from "./SurveyButton.vue?vue&type=script&lang=js"
import style0 from "./SurveyButton.vue?vue&type=style&index=0&id=d07221aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d07221aa",
  null
  
)

export default component.exports